import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=ba1944e0&scoped=true&"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=ba1944e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1944e0",
  null
  
)

export default component.exports